// Benepack OMS · GL-12 密码管理 Zod schema (自助改密 Modal + 管理员重置 Modal 共用)
// ★ 强度策略与后端唯一来源逐字一致 (apps/oms-identity/internal/usecase/user_helpers.go
//   ValidatePasswordStrength): 长度 ∈ [8, 128] + 至少 1 字母 + 1 数字 · 不发明新规则。
//   差异说明: 后端 len() 按字节计 · 前端按 UTF-16 code unit 计 —— 仅非 ASCII 密码有偏差
//   (后端仍兜底 · 前端校验只为交互友好)。字母/数字判定用 Unicode property escapes
//   (\p{L} / \p{Nd}) 对齐 Go unicode.IsLetter / unicode.IsDigit。
import { z } from 'zod';

/** 新密码强度字段 (8-128 · ≥1 字母 1 数字 · 同后端 OMS_IDENTITY_PASSWORD_WEAK 文案口径)。 */
export const PasswordStrengthField = z
  .string()
  .min(8, '密码长度至少 8 位')
  .max(128, '密码长度不得超过 128 位')
  .refine((v) => /\p{L}/u.test(v) && /\p{Nd}/u.test(v), '密码须同时含字母和数字');

/** 自助改密 (Topbar Modal · POST /identity/auth/change-password)。 */
export const ChangePasswordSchema = z
  .object({
    old_password: z.string().min(1, '请输入旧密码'),
    new_password: PasswordStrengthField,
    confirm_password: z.string().min(1, '请再次输入新密码'),
  })
  .refine((d) => d.new_password === d.confirm_password, {
    message: '两次输入的新密码不一致',
    path: ['confirm_password'],
  })
  // 与后端 usecase 同口径前置拦 (后端 same_as_old → 422 仍兜底)
  .refine((d) => d.new_password !== d.old_password, {
    message: '新密码不能与旧密码相同',
    path: ['new_password'],
  });
export type ChangePasswordInput = z.infer<typeof ChangePasswordSchema>;

/** 管理员重置 (users list Modal · POST /identity/users/{id}/reset-password · user:reset_password)。 */
export const ResetPasswordSchema = z
  .object({
    new_password: PasswordStrengthField,
    confirm_password: z.string().min(1, '请再次输入新密码'),
  })
  .refine((d) => d.new_password === d.confirm_password, {
    message: '两次输入的新密码不一致',
    path: ['confirm_password'],
  });
export type ResetPasswordInput = z.infer<typeof ResetPasswordSchema>;
